import { PayloadAction, SimpleAction } from 'interfaces/action'
import { createAction, createPayloadAction } from 'helpers/actionsHelpers'
import { Timeframe } from 'interfaces/chart'
import { CreditAccountCollection, CreditAnswer, CreditLinkagePhase, CreditQuestion, CreditTotals } from 'interfaces/credit'

// ===========================================================================//
//                                 CREDIT LINKAGE                             //
// ===========================================================================//

/*    QUESTIONS    */
export const SET_CREDIT_QUESTIONS = 'SET_CREDIT_QUESTIONS' as const
type SetCreditQuestions = PayloadAction<typeof SET_CREDIT_QUESTIONS, CreditQuestion[]>
export const setCreditQuestionsActionCreator = (payload: CreditQuestion[]) =>
  createPayloadAction(SET_CREDIT_QUESTIONS, payload)

// store an answer in state
export const SET_CREDIT_ANSWER = 'SET_CREDIT_ANSWER' as const
type SetCreditAnswer = PayloadAction<typeof SET_CREDIT_ANSWER, CreditAnswer>
export const setCreditAnswerActionCreator = (payload: CreditAnswer) =>
  createPayloadAction(SET_CREDIT_ANSWER, payload)

// send all the answers to a back end
export const SEND_CREDIT_ANSWERS = 'SEND_CREDIT_ANSWERS' as const
type SendCreditAnswers = SimpleAction<typeof SEND_CREDIT_ANSWERS>
export const sendCreditAnswersActionCreator = () => createAction(SEND_CREDIT_ANSWERS)

/*    OTHERS    */
export const SET_CREDIT_ERROR = 'SET_CREDIT_ERROR' as const
type SetCreditError = PayloadAction<typeof SET_CREDIT_ERROR, { error: string, source: CreditLinkagePhase | null }>
export const setCreditErrorActionCreator = (error: string, source: CreditLinkagePhase | null) =>
  createPayloadAction(SET_CREDIT_ERROR, { error, source })

// TODO rename reset to retry; make flow of working with credit linkage phase without "retry" action
export const RETRY_CREDIT = 'RETRY_CREDIT' as const
type RetryCredit = SimpleAction<typeof RETRY_CREDIT>
export const retryCreditActionCreator = (): RetryCredit => createAction(RETRY_CREDIT)

export const RESET_CREDIT = 'RESET_CREDIT' as const
type ResetCredit = SimpleAction<typeof RESET_CREDIT>
export const resetCreditActionCreator = (): ResetCredit => createAction(RESET_CREDIT)

export const CREDIT_LINKED = 'CREDIT_LINKED' as const
type CreditLinked = SimpleAction<typeof CREDIT_LINKED>
export const creditLinkedActionCreator = (): CreditLinked => createAction(CREDIT_LINKED)


// ===========================================================================//
//                                TOTALS & ACCOUNTS                           //
// ===========================================================================//

export const GET_CREDIT_TOTALS = 'GET_CREDIT_TOTALS' as const
type GetCreditTotals = PayloadAction<typeof GET_CREDIT_TOTALS, Timeframe>
export const getCreditTotalsActionCreator = (timeframe: Timeframe): GetCreditTotals =>
  createPayloadAction(GET_CREDIT_TOTALS, timeframe)

export const SET_CREDIT_TOTALS = 'SET_CREDIT_TOTALS' as const
type SetCreditTotals = PayloadAction<typeof SET_CREDIT_TOTALS, { timeframe: Timeframe, data: CreditTotals }>
export const setCreditTotalsActionCreator = (timeframe: Timeframe, data: CreditTotals): SetCreditTotals =>
  createPayloadAction(SET_CREDIT_TOTALS, { timeframe, data })

export const GET_CREDIT_ACCOUNTS = 'GET_CREDIT_ACCOUNTS' as const
type GetCreditAccounts = PayloadAction<typeof GET_CREDIT_ACCOUNTS, Timeframe>
export const getCreditAccountsActionCreator = (timeframe: Timeframe): GetCreditAccounts =>
  createPayloadAction(GET_CREDIT_ACCOUNTS, timeframe)

export const SET_CREDIT_ACCOUNTS = 'SET_CREDIT_ACCOUNTS' as const
type SetCreditAccounts = PayloadAction<typeof SET_CREDIT_ACCOUNTS, { timeframe: Timeframe, data: CreditAccountCollection }>
export const setCreditAccountsActionCreator = (timeframe: Timeframe, data: CreditAccountCollection): SetCreditAccounts =>
  createPayloadAction(SET_CREDIT_ACCOUNTS, { timeframe, data })


type Action =
  | SetCreditAnswer
  | SendCreditAnswers
  | SetCreditQuestions
  | SetCreditError
  | RetryCredit
  | ResetCredit
  | CreditLinked
  | GetCreditTotals
  | SetCreditTotals
  | GetCreditAccounts
  | SetCreditAccounts

export default Action
